import React, { useState } from 'react';
import Button from './Button';
import logo from './logo.svg';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100">
      {/* Reduced padding from py-2 to py-1 */}
      <nav className="max-w-8xl mx-auto flex items-center justify-between px-4 py-1">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <img 
            src={logo} 
            alt="Fylo" 
            className="w-20 h-auto cursor-pointer"
            onClick={() => document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' })} 
          />
        </div>
        {/* Desktop Links */}
        <div className="flex items-center gap-6">
          
          <a href="#footer" className="hidden sm:block text-sm text-gray-600 hover:text-black transition-colors">Contact</a>
          <a href="#build" className="hidden sm:block text-sm text-gray-600 hover:text-black transition-colors">Why Fylo</a>
          <Button onClick={() => navigate('/signin')} className="hidden sm:block" >Sign In</Button>

          {/* Hamburger - 2 lines, spaced apart */}
          <button
            className="sm:hidden flex flex-col gap-[10px] p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span
              className={`w-6 h-[2px] bg-black transition-transform duration-300 ${
                mobileMenuOpen ? 'rotate-45 translate-y-[5px]' : ''
              }`}
            ></span>
            <span
              className={`w-6 h-[2px] bg-black transition-transform duration-300 ${
                mobileMenuOpen ? '-rotate-45 -translate-y-[5px]' : ''
              }`}
            ></span>
          </button>
        </div>
      </nav>

      {/* Smooth Dropdown Animation */}
      <div
        className={`sm:hidden overflow-hidden transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] ${
          mobileMenuOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {/* Reduced padding from pb-3 pt-2 to pb-2 pt-1 */}
        <div className="bg-white border-t border-gray-100 px-4 pb-2 pt-1">
          <div className="flex flex-col gap-2">
           
            <a href="#footer" className="text-gray-600 hover:text-black transition-colors">Contact</a>
            <a href="#build" className="text-gray-600 hover:text-black transition-colors">Why Fylo</a>
            <Button onClick={() => navigate('/signin')}>Sign In</Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;